import * as type from '../actions/types';
import { safeParse } from '../utils/helpers';

const initialState = {
  data: 0,
  error: '',
  pending: true,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_NET_BALANCE_PENDING: {
      return {
        ...state,
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.FETCH_NET_BALANCE_SUCCESS: {
      return {
        ...state,
        data: safeParse(action.payload.data),
        pending: false,
        success: true,
      };
    }

    case type.FETCH_NET_BALANCE_FAILURE: {
      return {
        ...state,
        error: action.payload,
        pending: false,
      };
    }

    default: {
      return state;
    }
  }
};
